import { DOCUMENT_MODE } from "../../../constants/document";
import DummyCommand from "../dummyCommand";
import AddDocComponentCommand from "./addDocComponentCommand";
import AddTemplateComponentCommand from "./addTemplateComponentCommand";

class AddComponentBaseFactory {
  static getAddComponentCommandInstance(mode, isPDF, componentData) {
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      return new AddDocComponentCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      return new AddTemplateComponentCommand(componentData);
    }

    return new DummyCommand();
  }
}

export default AddComponentBaseFactory;
